import React, { useEffect } from 'react'
import { Button } from '../../../components/button'
import { useDispatch, useSelector } from 'react-redux'
import { getPlanGroups } from '../../../slices/plangroups'
import { getDiscounts } from '../../../slices/discount'
import { Link, useNavigate } from "react-router-dom";
import { SvgRecycleBin } from '../../../components/svg';

const Discounts = () => {

    const dispatch = useDispatch()
    const discounts = useSelector((state) => state.discounts.results)
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getDiscounts())
    }, [])

    // return <div>Henlo!</div>

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{gettext('Discount Groups')}</h1>
                        <Link to={"new"}><Button variant={"secondary"} size={"sm"}>{gettext('Add a Discount Group')}</Button></Link>
                    </div>
                </div>
            </div>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-12 mb-4 overflow-scroll">
                            <table className="table table-hover component-table">
                                <thead className="bold">
                                    <tr>
                                        <th>{gettext('Name')}</th>
                                        <th>{gettext('Discount')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {discounts.map((discount) =>
                                        <tr key={discount.id}>
                                            <th>{discount.name}</th>
                                            <td>{discount.discount}%</td>
                                            <td className="text-center"><SvgRecycleBin /></td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Discounts